require("!!/home/jenkins/agent/workspace/hybrid-accsts-task-release/hybrid-accsts-jsclient/target/toolchain/node_modules/script-loader/addScript.js")(require("!!/home/jenkins/agent/workspace/hybrid-accsts-task-release/hybrid-accsts-jsclient/target/toolchain/node_modules/raw-loader/index.js!/home/jenkins/agent/workspace/hybrid-accsts-task-release/hybrid-accsts-jsclient/target/toolchain/node_modules/source-map-loader/index.js!/home/jenkins/agent/workspace/hybrid-accsts-task-release/hybrid-accsts-jsclient/target/toolchain/vendor/scripts/backbone.controller.js"))


//////////////////
// WEBPACK FOOTER
// ./vendor/scripts/backbone.controller.js
// module id = 404
// module chunks = 1